import AirportsData from "./Airports";

global.autoSelectAirportOrCityForHotelSearchInputField = (IATA_ICAO, field_id) => {
    if(!IATA_ICAO || typeof IATA_ICAO!=="string"){
        return false;
    }
    let airports = AirportsData.filter(each=>(
        each.IATA.toLowerCase().trim()===IATA_ICAO.toLowerCase().trim()
        || each.ICAO.toLowerCase().trim()===IATA_ICAO.toLowerCase().trim()));
    if(airports.length<1){
        return false;
    }
    let item=airports[0];
    const airport=`${item.city} - ${item.name} (${item.IATA})`;
    const iata=item.IATA;
    const icao=item.ICAO;
    let html_elem=document.getElementById(field_id);
    if(html_elem){
        html_elem.value = airport;
        if(iata === "\\N" || iata === "N"){
            html_elem.value = airport.split("(")[0] + " (" + icao + ")";
        }
    }
    
    return item;
    
}

const HotelsAutoCompleteInit = () => {
    // Array filter method wrapped in function to improve code reuse
    function hotels_filter_airports_array_based_input_value(elem_value){

        return AirportsData.filter(each => {
            return (
            each.city.toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", "")) 
            || each.name.toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || each.IATA.toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || each.country.toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.city + each.name).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.city + each.country).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.city + each.country + each.name + each.IATA).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.country + each.city + each.name + each.IATA).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.name + each.city + each.country + each.IATA).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.name + each.IATA + each.city + each.country).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.IATA + each.name + each.city + each.country).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.IATA + each.city + each.name + each.country).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.IATA + each.city + each.country + each.name).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            || (each.IATA + each.country + each.city + each.name).toLowerCase().replaceAll(" ", "").includes(elem_value.toLowerCase().replaceAll(" ", ""))
            )
        });

    }

    // Making filter function global;
    window.hotels_filter_airports_array_based_input_value=hotels_filter_airports_array_based_input_value;

    // Origin For Hotel Search
    if(document.getElementById("hotel_from_where_city_auto_complete_input_fld")){
        document.getElementById("hotel_from_where_city_auto_complete_input_fld").addEventListener("input", (evnt)=>{
            let counter = 0;
            document.getElementById("hotels_auto_complete_from_where_input_list").innerHTML = "";
            let flights = [];

            //if backspace has been pressed, don't auto-complete on input
            if(!evnt.data){ //Backspace
                // Remove this condition for now
                //return null;
            }

            if(evnt.target.value){

                flights = hotels_filter_airports_array_based_input_value(evnt.target.value);

                flights = flights.map(elem => {
                        counter++;
                        return counter < 9 && `
                            <li><div onclick="hotelsChangeAirportsOrCityOriginInput('${elem?.city} - ${elem?.name} (${elem?.IATA})', '${elem?.IATA}', '${elem?.ICAO}', '${elem?.lon}', '${elem?.lat}');" class="autocomplete_list_each_item_container">
                                <div>
                                    <p class="autocomplete_list_airport_city_name">
                                        <i class="fa fa-plane"></i>
                                        ${elem?.city} (${elem?.IATA} - ${elem?.name})
                                    </p>
                                    <p class="autocomplete_list_country_name">
                                        ${elem?.country}
                                    </p>
                                </div>
                            </div></li>`;
                        
                    })
            }
            //console.log(flights);
            document.getElementById("hotels_auto_complete_from_where_input_list").innerHTML = flights.join('').replaceAll("false","");
        })
    }

    window.hotelsChangeAirportsOrCityOriginInput = function(airport, iata, icao, lon="", lat=""){
        if(document.getElementById("hotel_from_where_city_auto_complete_input_fld"))
            document.getElementById("hotel_from_where_city_auto_complete_input_fld").value = airport;
        if(document.getElementById("hotel_search_forms_from_where_input_fld"))
            document.getElementById("hotel_search_forms_from_where_input_fld").value = airport;
        hotels_add_origin_input_airport_to_history(iata)

        let hotel_search_data = JSON.parse(localStorage.getItem("hotel_search_obj"));
        hotel_search_data.flights.origin_airport.iata = iata;
        hotel_search_data.flights.origin_airport.long = lon;
        hotel_search_data.flights.origin_airport.lat = lat;
        
        if(iata === "\\N" || iata === "N"){
            hotels_add_origin_input_airport_to_history(icao)
            hotel_search_data.flights.origin_airport.iata = icao;
            if(document.getElementById("hotel_from_where_city_auto_complete_input_fld"))
                document.getElementById("hotel_from_where_city_auto_complete_input_fld").value = airport.split("(")[0] + " (" + icao + ")";
            if(document.getElementById("hotel_search_forms_from_where_input_fld"))
                document.getElementById("hotel_search_forms_from_where_input_fld").value = airport.split("(")[0] + " (" + icao + ")";
        }

        window.localStorage.setItem("hotel_search_obj", JSON.stringify(hotel_search_data));
    }

    function hotel_show_all_origin_airport_history(){

        if(document.getElementById("hotels_auto_complete_from_where_input_list"))
            document.getElementById("hotels_auto_complete_from_where_input_list").innerHTML = "";
        let airports_history = JSON.parse(window.localStorage.getItem(LCLSTRGE_HISTORY_NAME));
        console.log(airports_history)
        for(let i = (airports_history.from.length-1); ; ){
            let airport;
            if(i<0) break;
            airport = AirportsData.filter(each => {
                return (each.IATA === airports_history.from[i] || each.ICAO === airports_history.from[i]);
            });
            if(airport.length===0){ 
                i--;
                continue;
            }
            if(document.getElementById("hotels_auto_complete_from_where_input_list"))
                document.getElementById("hotels_auto_complete_from_where_input_list").innerHTML += hotel_return_history_markup(airport[0], "origin");
            i--;
        }
    }
    if(document.getElementById("hotel_search_forms_from_where_input_fld")){
        document.getElementById("hotel_search_forms_from_where_input_fld").addEventListener("click", e => {
            hotel_show_all_origin_airport_history();
        });
    }

    // Destination For Hotel Search
    if(document.getElementById("hotel_to_where_city_auto_complete_input_fld")){
        document.getElementById("hotel_to_where_city_auto_complete_input_fld").addEventListener("input", (evnt)=>{
            let counter = 0;
            document.getElementById("hotels_auto_complete_to_where_input_list").innerHTML = "";
            let flights = [];

            //if backspace has been pressed, don't auto-complete on input
            if(!evnt.data){ //Backspace
                // Remove this condition for now
                //return null;
            }

            if(evnt.target.value){

                flights = hotels_filter_airports_array_based_input_value(evnt.target.value);

                flights = flights.map(elem => {
                        counter++;
                        return counter < 9 && `
                            <li><div onclick="hotelsChangeAirportsOrCityDestinationInput('${elem?.city} - ${elem?.name} (${elem?.IATA})', '${elem?.IATA}', '${elem?.ICAO}', '${elem?.lon}', '${elem?.lat}');" class="autocomplete_list_each_item_container">
                                <div>
                                    <p class="autocomplete_list_airport_city_name">
                                        <i class="fa fa-plane"></i>
                                        ${elem?.city} (${elem?.IATA} - ${elem?.name})
                                    </p>
                                    <p class="autocomplete_list_country_name">
                                        ${elem?.country}
                                    </p>
                                </div>
                            </div></li>`;
                        
                    })
            }
            //console.log(flights);
            document.getElementById("hotels_auto_complete_to_where_input_list").innerHTML = flights.join('').replaceAll("false","");
        })
    }

    window.hotelsChangeAirportsOrCityDestinationInput = function(airport, iata, icao, lon="", lat=""){
        if(document.getElementById("hotel_to_where_city_auto_complete_input_fld"))
            document.getElementById("hotel_to_where_city_auto_complete_input_fld").value = airport;
        if(document.getElementById("hotel_search_forms_to_where_input_fld"))
            document.getElementById("hotel_search_forms_to_where_input_fld").value = airport;
        hotels_add_destination_input_airport_to_history(iata)

        let hotel_search_data = JSON.parse(localStorage.getItem("hotel_search_obj"));
        hotel_search_data.location.iata = iata;
        hotel_search_data.location.long = lon;
        hotel_search_data.location.lat = lat;
        
        if(iata === "\\N" || iata === "N"){
            hotels_add_destination_input_airport_to_history(icao)
            hotel_search_data.location.iata = icao;
            if(document.getElementById("hotel_to_where_city_auto_complete_input_fld"))
                document.getElementById("hotel_to_where_city_auto_complete_input_fld").value = airport.split("(")[0] + " (" + icao + ")";
            if(document.getElementById("hotel_search_forms_to_where_input_fld"))
                document.getElementById("hotel_search_forms_to_where_input_fld").value = airport.split("(")[0] + " (" + icao + ")";
        }

        window.localStorage.setItem("hotel_search_obj", JSON.stringify(hotel_search_data));
    }

    function hotel_show_all_destination_airport_history(){

        if(document.getElementById("hotels_auto_complete_to_where_input_list"))
            document.getElementById("hotels_auto_complete_to_where_input_list").innerHTML = "";
        let airports_history = JSON.parse(window.localStorage.getItem(LCLSTRGE_HISTORY_NAME));
        for(let i = (airports_history.to.length-1); ; ){
            let airport;
            if(i<0) break;
            airport = AirportsData.filter(each => {
                return (each.IATA === airports_history.to[i] || each.ICAO === airports_history.to[i]);
            });
            if(airport.length===0){ 
                i--;
                continue;
            }
            if(document.getElementById("hotels_auto_complete_to_where_input_list"))
                document.getElementById("hotels_auto_complete_to_where_input_list").innerHTML += hotel_return_history_markup(airport[0], "");
            i--;
        }
    }
    if(document.getElementById("hotel_search_forms_to_where_input_fld")){
        document.getElementById("hotel_search_forms_to_where_input_fld").addEventListener("click", e => {
            hotel_show_all_destination_airport_history();
        });
    }

    // Search Origin/Destination Input History Function
    let hotels_aiports_input_history = {
        from: [],
        to: []
    }
    const LCLSTRGE_HISTORY_NAME="hotels_airports_input_history"
    if(!localStorage.getItem(LCLSTRGE_HISTORY_NAME)){
        localStorage.setItem(LCLSTRGE_HISTORY_NAME, JSON.stringify(hotels_aiports_input_history));
    }

    function hotels_add_origin_input_airport_to_history(aita){

        if(window.localStorage.getItem(LCLSTRGE_HISTORY_NAME)){
            let airports_history = JSON.parse(window.localStorage.getItem(LCLSTRGE_HISTORY_NAME));
            
            //removing existing same vlaue
            airports_history.from = airports_history?.from?.filter(each => {
                return (each !== aita)
            });

            let temp_airports = [];
            if(airports_history?.from?.length > 4){
                for(let i=1; i<5; i++){
                    temp_airports?.push(airports_history?.from[i]);
                }
                airports_history.from = [...temp_airports, aita];
            }else{
                airports_history?.from?.push(aita);
            }
            localStorage.setItem(LCLSTRGE_HISTORY_NAME, JSON.stringify(airports_history));
        }else{
            hotels_aiports_input_history?.from?.push(aita);
            window.localStorage.setItem(LCLSTRGE_HISTORY_NAME, JSON.stringify(hotels_aiports_input_history));
        }
        
    }

    function hotels_add_destination_input_airport_to_history(aita){

        if(window.localStorage.getItem(LCLSTRGE_HISTORY_NAME)){
            let airports_history = JSON.parse(window.localStorage.getItem(LCLSTRGE_HISTORY_NAME));
            
            //removing existing same vlaue
            airports_history.to = airports_history?.to?.filter(each => {
                return (each !== aita)
            });

            let temp_airports = [];
            if(airports_history?.to?.length > 4){
                for(let i=1; i<5; i++){
                    temp_airports?.push(airports_history?.to[i]);
                }
                airports_history.to = [...temp_airports, aita];
            }else{
                airports_history?.to?.push(aita);
            }
            localStorage.setItem(LCLSTRGE_HISTORY_NAME, JSON.stringify(airports_history));
        }else{
            hotels_aiports_input_history?.to?.push(aita);
            window.localStorage.setItem(LCLSTRGE_HISTORY_NAME, JSON.stringify(hotels_aiports_input_history));
        }
        
    }

    function hotel_return_history_markup(obj, type){
        if(!obj) return "";
        if(type === "origin"){
            return `
                <li><div onclick="hotelsChangeAirportsOrCityOriginInput('${obj?.city} - ${obj?.name} (${obj?.IATA})', '${obj?.IATA}', '${obj?.ICAO}', '${obj?.lon}', '${obj?.lat}');" style="padding: 10px; display: flex; flex-direction: row; cursor: pointer;">
                    <div style="height: 35px; margin-right: 15px; display: flex; flex-direction: column; justify-content: center;">
                        <i class="fa fa-history" style="color: rgba(0,0,0,0.3); font-size: 22px;"></i>
                    </div>
                    <div>
                        <div>
                            <p style="font-size: 14px; color: rgba(0,0,0,0.9); font-family: 'Prompt', sans-serif;">
                                ${obj?.city} (${(obj?.IATA === "\\N" || obj?.IATA === "N") ? obj?.ICAO : obj?.IATA} - ${obj?.name})
                            </p>
                            <p style="font-size: 13px; color: rgba(0,0,0,0.8);">
                                ${obj?.country}
                            </p>
                        </div>
                    </div>
                </div></li>
            `;
        }else{
            return `
                <li><div onclick="hotelsChangeAirportsOrCityDestinationInput('${obj?.city} - ${obj?.name} (${obj?.IATA})', '${obj?.IATA}', '${obj?.ICAO}', '${obj?.lon}', '${obj?.lat}');" style="padding: 10px; display: flex; flex-direction: row; cursor: pointer;">
                    <div style="height: 35px; margin-right: 15px; display: flex; flex-direction: column; justify-content: center;">
                        <i class="fa fa-history" style="color: rgba(0,0,0,0.3); font-size: 22px;"></i>
                    </div>
                    <div>
                        <div>
                            <p style="font-size: 14px; color: rgba(0,0,0,0.9); font-family: 'Prompt', sans-serif;">
                                ${obj?.city} (${(obj?.IATA === "\\N" || obj?.IATA === "N") ? obj?.ICAO : obj?.IATA} - ${obj?.name})
                            </p>
                            <p style="font-size: 13px; color: rgba(0,0,0,0.8);">
                                ${obj?.country}
                            </p>
                        </div>
                    </div>
                </div></li>
            `;
        }
        
    }

}

export default HotelsAutoCompleteInit